<div class="icon-button">
  <vi-icon-button (click)="toggleMenu()">menu</vi-icon-button>
</div>
